import React from "react";

interface CalendarDaysIllustrationProps {
  className?: string;
}

export const CalendarDaysIllustration: React.FC<
  CalendarDaysIllustrationProps
> = ({ className = "h-24 w-24" }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      {/* Calendar body */}
      <rect
        x="18"
        y="28"
        width="84"
        height="74"
        rx="8"
        className="fill-white stroke-secondary-300"
        strokeWidth="2"
      />
      {/* Header */}
      <path d="M18 44H102" className="stroke-secondary-200" strokeWidth="2" />
      {/* Rings */}
      <circle cx="38" cy="28" r="5" className="fill-primary-400" />
      <circle cx="82" cy="28" r="5" className="fill-primary-400" />
      {/* Day grid squares with a few highlighted */}
      <rect
        x="30"
        y="56"
        width="10"
        height="10"
        rx="2"
        className="fill-primary-200"
      />
      <rect
        x="48"
        y="56"
        width="10"
        height="10"
        rx="2"
        className="fill-secondary-100"
      />
      <rect
        x="66"
        y="56"
        width="10"
        height="10"
        rx="2"
        className="fill-primary-200"
      />
      <rect
        x="84"
        y="56"
        width="10"
        height="10"
        rx="2"
        className="fill-secondary-100"
      />
      <rect
        x="30"
        y="74"
        width="10"
        height="10"
        rx="2"
        className="fill-secondary-100"
      />
      <rect
        x="48"
        y="74"
        width="10"
        height="10"
        rx="2"
        className="fill-primary-200"
      />
      <rect
        x="66"
        y="74"
        width="10"
        height="10"
        rx="2"
        className="fill-secondary-100"
      />
      <rect
        x="84"
        y="74"
        width="10"
        height="10"
        rx="2"
        className="fill-primary-200"
      />
    </svg>
  );
};
